var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as actions from '../constants/actionTypes';
import callApi from '../graphql/callApi';
import sagaFactory from '../utils/sagaFactory';
export var getConsolidations = sagaFactory('getConsolidations', actions.getConsolidations, callApi.getConsolidations, 'consolidations');
export var getContainers = sagaFactory('getContainers', actions.getContainers, callApi.getContainers, 'consolidations');
export var getConsolidationById = sagaFactory('getConsolidationById', actions.getConsolidationById, callApi.getConsolidationById, 'consolidations');
export var getPackageConsolidation = sagaFactory('getPackageConsolidation', actions.getPackageConsolidation, callApi.getPackageConsolidation, 'getPackageConsolidation');
export var createConsolidation = sagaFactory('createConsolidation', actions.createConsolidation, callApi.createConsolidation, 'createConsolidation');
export var createOutboundConsolidation = sagaFactory('createOutboundConsolidation', actions.createOutboundConsolidation, callApi.createOutboundConsolidation, 'createOutboundConsolidation');
export var updateConsolidation = sagaFactory('updateConsolidation', actions.updateConsolidation, callApi.updateConsolidation, 'updateConsolidation');
export var getPackingSlipByConsolidationId = sagaFactory('getPackingSlipByConsolidationId', actions.getPackingSlipByConsolidationId, callApi.getPackingSlipByConsolidationId, 'packingSlipByConsolidationId');
export var registerConsolidationScan = sagaFactory('registerConsolidationScan', actions.registerConsolidationScan, callApi.registerConsolidationScan, 'registerConsolidationScan');
export var createConsolidationPackage = sagaFactory('createConsolidationPackage', actions.createConsolidationPackage, callApi.createConsolidationPackage, 'createConsolidationPackage');
export var deleteConsolidationPackage = sagaFactory('deleteConsolidationPackage', actions.deleteConsolidationPackage, callApi.deleteConsolidationPackage, 'deleteConsolidationPackage');
export function createConsolidationAddress(_a) {
    var res, destination, err_1, message;
    var _b, _c;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 11, , 13]);
                return [4 /*yield*/, call(callApi.createAddress, {
                        name: payload.name,
                        phone: payload.phone,
                        street: payload.street,
                        unit: payload.unit,
                        city: payload.city,
                        state: payload.state || '',
                        zipCode: payload.zipCode,
                        instructions: payload.instructions || '',
                        nickname: '',
                        isDefault: true,
                        geocode: !payload.ignoreGeocoding,
                    }, payload.skipServicedArea)];
            case 1:
                res = _d.sent();
                if (!((_b = res.data) === null || _b === void 0 ? void 0 : _b.createAddress)) return [3 /*break*/, 8];
                return [4 /*yield*/, call(callApi.createPartnerDestination, {
                        partnerCode: payload.partnerCode,
                        addressId: res.data.createAddress.id,
                    })];
            case 2:
                destination = _d.sent();
                if (!((_c = destination.data) === null || _c === void 0 ? void 0 : _c.createPartnerDestination)) return [3 /*break*/, 4];
                return [4 /*yield*/, put({
                        type: actions.createPartnerDestination.type.SUCCESS,
                        payload: {
                            destination: destination.data.createPartnerDestination,
                            partnerCode: payload.partnerCode,
                        },
                    })];
            case 3:
                _d.sent();
                next(destination.data.createPartnerDestination);
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, call(callApi.deleteAddress, res.data.createAddress.id)];
            case 5:
                _d.sent();
                throw new Error('Something went wrong, try again later');
            case 6: return [4 /*yield*/, put({
                    type: actions.createConsolidationAddress.type.SUCCESS,
                })];
            case 7:
                _d.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, put({
                    type: actions.createConsolidationAddress.type.FAILED,
                })];
            case 9:
                _d.sent();
                next(false, 'Something went wrong, try again later');
                _d.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11:
                err_1 = _d.sent();
                message = err_1.message;
                console.error('createConsolidationAddress', err_1);
                next(false, message || 'Something went wrong, try again later');
                return [4 /*yield*/, put({
                        type: actions.createConsolidationAddress.type.FAILED,
                    })];
            case 12:
                _d.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
export function deleteConsolidationAddress(_a) {
    var res, destination, err_2, message;
    var _b, _c;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 10, , 12]);
                return [4 /*yield*/, call(callApi.deleteAddress, payload.addressId)];
            case 1:
                res = _d.sent();
                if (!((_b = res.data) === null || _b === void 0 ? void 0 : _b.deleteAddress)) return [3 /*break*/, 7];
                return [4 /*yield*/, call(callApi.deletePartnerDestination, {
                        id: payload.partnerDestinationId,
                    })];
            case 2:
                destination = _d.sent();
                if (!((_c = destination.data) === null || _c === void 0 ? void 0 : _c.deletePartnerDestination)) return [3 /*break*/, 4];
                return [4 /*yield*/, put({
                        type: actions.deletePartnerDestination.type.SUCCESS,
                        payload: {
                            id: destination.data.deletePartnerDestination.id,
                        },
                    })];
            case 3:
                _d.sent();
                next(destination.data.deletePartnerDestination);
                return [3 /*break*/, 5];
            case 4: throw new Error('Something went wrong, try again later');
            case 5: return [4 /*yield*/, put({
                    type: actions.deleteConsolidationAddress.type.SUCCESS,
                })];
            case 6:
                _d.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, put({
                    type: actions.deleteConsolidationAddress.type.FAILED,
                })];
            case 8:
                _d.sent();
                next(false, 'Something went wrong, try aging later');
                _d.label = 9;
            case 9: return [3 /*break*/, 12];
            case 10:
                err_2 = _d.sent();
                message = err_2.message;
                console.error('deleteConsolidationAddress', err_2);
                next(false, message || 'Something went wrong, try aging later');
                return [4 /*yield*/, put({
                        type: actions.deleteConsolidationAddress.type.FAILED,
                    })];
            case 11:
                _d.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function consolidationsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actions.getConsolidations.type.REQUEST, getConsolidations)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getContainers.type.REQUEST, getContainers)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getPackageConsolidation.type.REQUEST, getPackageConsolidation)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createConsolidation.type.REQUEST, createConsolidation)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createOutboundConsolidation.type.REQUEST, createOutboundConsolidation)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.updateConsolidation.type.REQUEST, updateConsolidation)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createConsolidationAddress.type.REQUEST, createConsolidationAddress)];
            case 7:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deleteConsolidationAddress.type.REQUEST, deleteConsolidationAddress)];
            case 8:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPackingSlipByConsolidationId.type.REQUEST, getPackingSlipByConsolidationId)];
            case 9:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createConsolidationPackage.type.REQUEST, createConsolidationPackage)];
            case 10:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.deleteConsolidationPackage.type.REQUEST, deleteConsolidationPackage)];
            case 11:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.registerConsolidationScan.type.REQUEST, registerConsolidationScan)];
            case 12:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getConsolidationById.type.REQUEST, getConsolidationById)];
            case 13:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default consolidationsSaga;
//# sourceMappingURL=consolidations.js.map